import styles from "./app.module.css";
import { useEffect, useRef, useState } from 'react';
import Header from './app/components/header/Header';
import Cursor from './app/components/cursor/Cursor';
import Home from "./app/pages/home/Home";
import { FluidSimulation, Footer, Loading } from "./app/components";
import { AboutUs, BlogDetail, BlogListing, Client, ContactUs, Influencers, LiveFeeds, Podcast, Service, ServiceDetail, Work, WorkDetail } from "./app/pages";
import { Route, Routes, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./app/store/store";
import { useTranslation } from "react-i18next";
import CursorTrail from "./app/components/cursor/CursorTrail";

function App() {
    const stickyElement = useRef(null);
    const [loading, setLoading] = useState(true);
    const [loadDuration, setLoadDuration] = useState(0); // To track the loading time dynamically
    const location = useLocation();
    const { t, i18n } = useTranslation();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang); // Change the current language
    };

    // Calculate and set the loading time dynamically
    useEffect(() => {
        const startTime = performance.now(); // Start time before component loading
        setLoading(true); // Show loader

        // Simulate a delay to show the loader (minimum 300ms)
        const timeout = setTimeout(() => {
            const endTime = performance.now(); // End time after component rendering
            const duration = Math.max(300, endTime - startTime); // Ensure at least 300ms
            setLoadDuration(duration); // Save the calculated loading time
            setLoading(false); // Hide loader
        }, 300); // Minimum delay for user experience

        return () => clearTimeout(timeout); // Cleanup timeout on unmount
    }, [location]);

    if (loading) {
        return <Loading />;
    }

    // Check if the current path is the home page
    const isHomePage = location.pathname === "/";

    return (
        <Provider store={store}>
            <div className={styles.main}>
                {/* <Cursor stickyElement={stickyElement} /> */}

                <FluidSimulation />
                <CursorTrail />
                <Header ref={stickyElement} isHomePage={isHomePage} />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/our-work" element={<Work />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/what-we-do" element={<Service />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/client" element={<Client />} />
                    <Route path="/podcast" element={<Podcast />} />
                    <Route path="/influencers" element={<Influencers />} />
                    {/* <Route path="/blogs" element={<BlogListing />} /> */}
                    <Route path="/live-feeds" element={<LiveFeeds />} />
                    <Route path="/what-we-do/:serviceId" element={<ServiceDetail />} />
                    {/*  <Route path="/blog-detail/:blogId" element={<BlogDetail />} /> */}
                    <Route path="/our-work/work-detail/:workId" element={<WorkDetail />} />
                </Routes>
                <Footer />

            </div>
        </Provider>
    );
}

export default App;
